
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinnanded() {



const cardData = {
  keyword: 'Cab Service in Nanded MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Nanded MIDC for Seamless Business Travel',
  headingDescription: 'Serving the bustling industrial zone of Nanded MIDC, eTravo offers comprehensive corporate cab services designed to meet the diverse transportation needs of industries and businesses. Our fleet is equipped with the latest safety and comfort features, ensuring timely and efficient commutes for employees, executives, and clients. From daily employee pickups to executive business travel and shuttle services, we focus on reliability and affordability to boost your operational efficiency. Whether you run a manufacturing unit, IT firm, or logistic company in Nanded MIDC, our services are tailored to keep your workforce mobile and punctual.',

  top: 'Key Industrial Areas Covered within Nanded MIDC',
  topPlaces: [
    {
      title: 'Nanded Industrial Estate',
      description: 'The core industrial area housing SMEs and large manufacturers. We provide scalable cab services to ensure smooth employee transport and reduce downtime across multiple shifts.'
    },
    {
      title: 'Pharmaceutical Clusters',
      description: 'Specialized employee transport services catering to pharma units requiring strict timing and hygiene protocols, with AC cabs for enhanced comfort.'
    },
    {
      title: 'Logistics and Warehousing Zones',
      description: 'Reliable shuttle and cargo staff transportation solutions supporting logistics companies operating 24/7 across Nanded MIDC.'
    },
    {
      title: 'IT and Service Sectors',
      description: 'Executive and business meeting cab services tailored for IT firms and corporate offices in the area, including airport transfers.'
    },
    {
      title: 'Nearby Residential Localities',
      description: 'Connecting major residential areas like Bhaskarnagar, Anand Nagar, and Saraswati Nagar to Nanded MIDC industrial hubs with efficient shuttle cabs.'
    }
  ],

  services: [
    {
      name: 'Nanded MIDC Corporate Cab Rentals',
      description: 'Offering flexible cab rental plans designed to suit the unique requirements of businesses in Nanded MIDC. Our rentals range from daily to monthly packages, accommodating both small teams and large workforces with dedicated vehicles. Each cab is driven by trained professionals, ensuring a smooth, punctual, and safe commute for your employees.'
    },
    {
      name: 'Employee Transport Cab Nanded MIDC',
      description: 'Customized employee transport solutions for factories and industrial units, ensuring timely pickup and drop-off aligned with shift timings. Our GPS-enabled fleet provides real-time tracking for management, enhancing safety and operational efficiency. We serve various shifts, minimizing absenteeism and optimizing workforce productivity.'
    },
    {
      name: 'Business Cab Services Nanded MIDC',
      description: 'Designed for professionals requiring hassle-free travel to business meetings, client visits, and inter-office trips. Our fleet includes sedans and SUVs equipped with modern amenities, ensuring comfort and professionalism for your corporate travelers.'
    },
    {
      name: 'Corporate Staff Cabs Nanded MIDC',
      description: 'Efficient staff cab services catering to large teams with or dedicated rides, ensuring seamless transportation across the industrial estate. Vehicles are maintained with high hygiene standards, and drivers are trained in courteous customer service to provide a pleasant travel experience.'
    },
    {
      name: 'Reliable Corporate Cab Service Nanded MIDC',
      description: 'Committed to delivering punctual and safe transport services with a fleet monitored through advanced GPS systems. Our service reliability minimizes delays and ensures that your employees and clients reach their destinations on time, every time.'
    },
    {
      name: 'AC Corporate Cabs Nanded MIDC',
      description: 'Comfortable, fully air-conditioned cabs designed to provide relief from Nanded’s climate. Our AC fleet ensures a refreshing travel experience, especially for long-distance commutes or executive travel within the industrial zone.'
    },
    {
      name: 'Staff Pickup and Drop Cab Nanded MIDC',
      description: 'Organized pickup and drop services supporting multiple shifts, ensuring all employees have access to safe, reliable transport. We optimize routes to reduce travel time and maximize efficiency, backed by live vehicle tracking for transparency.'
    },
    {
      name: 'Affordable Business Cab Rentals Nanded MIDC',
      description: 'Cost-effective rental options suited for startups and SMEs, providing reliable corporate transportation without compromising on quality. Transparent pricing and flexible plans help you manage budgets effectively while maintaining staff mobility.'
    },
    {
      name: 'Executive Cab Services Nanded MIDC',
      description: 'Premium cab services for executives and high-profile clients featuring luxury vehicles, professional chauffeurs, and personalized services. Ideal for airport transfers, client meetings, and factory tours that require a touch of elegance and reliability.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Nanded MIDC',
      description: 'Our monthly rental packages cater to companies with ongoing transportation needs, offering dedicated vehicles and drivers. This service ensures consistency, cost savings, and simplified fleet management for your corporate travel requirements.'
    },
    {
      name: 'Industrial Area Employee Transport Nanded MIDC',
      description: 'Specialized transport services designed for industrial workers, supporting the seamless flow of labor to and from the factories. Safety and timeliness are prioritized to keep your production lines running smoothly.'
    },
    {
      name: 'Corporate Client Cabs Nanded MIDC',
      description: 'Hospitality-focused cab services for visiting clients and business partners. We provide comfortable, professional rides with prompt pickups and drop-offs to make a positive impression and facilitate smooth business interactions.'
    },
    {
      name: 'Business Meeting Cabs Nanded MIDC',
      description: 'Reliable and punctual cab services for attending business meetings, conferences, and site visits. Our drivers are knowledgeable about local routes, helping you avoid traffic and ensuring timely arrivals.'
    },
    {
      name: 'Nanded Industrial Area Cab Hire',
      description: 'Short-term and on-demand cab hire services for industrial purposes, including project-based teams and event transport. Our vehicles are well-maintained and available with flexible booking options.'
    },
    {
      name: 'Corporate Shuttle Cabs Nanded MIDC',
      description: 'Daily shuttle services connecting residential neighborhoods with the industrial area, offering a cost-effective and convenient transport solution for employees. Regular schedules and monitored fleets enhance reliability.'
    }
  ],

  tableData: [
    ['Nanded MIDC Corporate Cab Rentals', 'Employee Transport Cab Nanded MIDC'],
    ['Business Cab Services Nanded MIDC', 'Corporate Staff Cabs Nanded MIDC'],
    ['Reliable Corporate Cab Service Nanded MIDC', 'AC Corporate Cabs Nanded MIDC'],
    ['Staff Pickup and Drop Cab Nanded MIDC', 'Affordable Business Cab Rentals Nanded MIDC'],
    ['Executive Cab Services Nanded MIDC', 'Monthly Corporate Cab Rentals Nanded MIDC'],
    ['Industrial Area Employee Transport Nanded MIDC', 'Corporate Client Cabs Nanded MIDC'],
    ['Business Meeting Cabs Nanded MIDC', 'Nanded Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Nanded MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Dedicated Corporate Cab Services for Nanded MIDC",
    "WhyChoosedescription": "eTravo offers reliable and efficient corporate cab services tailored for companies located in Nanded MIDC, an emerging industrial hub in Maharashtra. We understand the critical role timely and safe employee transportation plays in productivity. Our customized mobility solutions are built to support manufacturing units, warehouses, and business parks in the region by ensuring smooth and hassle-free commutes for staff and executives alike."
  },
  {
    "WhyChooseheading": "Comprehensive Fleet Covering All Corporate Needs",
    "WhyChoosedescription": "From compact sedans for executive travel to spacious MUVs for employee group transport, our diverse fleet addresses a wide range of corporate travel scenarios. Every vehicle is regularly serviced, air-conditioned, and equipped with safety features to guarantee a comfortable experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Nanded MIDC Routes",
    "WhyChoosedescription": "Our drivers are well-versed with the local roadways and traffic patterns in and around Nanded MIDC. Their local expertise ensures time-efficient commutes, safe driving practices, and a courteous approach, reducing delays and ensuring reliability across all rides."
  },
  {
    "WhyChooseheading": "Flexible Booking and Shift Scheduling Options",
    "WhyChoosedescription": "Whether your company runs fixed shifts or operates on a flexible schedule, we offer dynamic booking solutions to meet your specific needs. Options include daily pick-ups, multiple-route planning, and round-the-clock service availability for 24/7 manufacturing units."
  },
  {
    "WhyChooseheading": "Real-Time Tracking with Centralized Monitoring",
    "WhyChoosedescription": "All vehicles are GPS-enabled and monitored in real time, allowing corporate managers to track trips and ensure accountability. This provides added safety for passengers and greater visibility for HR and operations teams managing employee mobility."
  },
  {
    "WhyChooseheading": "Transparent Billing and Detailed Reporting",
    "WhyChoosedescription": "We provide clear, itemized invoices with trip logs, timings, and fare breakdowns. This simplifies financial tracking for businesses, supports audit processes, and helps in monthly budget forecasting for transportation costs."
  },
  {
    "WhyChooseheading": "Strict Hygiene & Safety Protocols Across Fleet",
    "WhyChoosedescription": "All our vehicles undergo routine cleaning and sanitization. Drivers follow stringent hygiene practices, including wearing masks and undergoing health checks. These measures are critical for employee well-being, especially or long-distance commutes."
  },
  {
    "WhyChooseheading": "Corporate Account Management with Dedicated Support",
    "WhyChoosedescription": "Every corporate client benefits from a dedicated account manager who offers end-to-end assistance—handling bookings, custom route planning, invoicing queries, and ensuring seamless communication throughout the partnership."
  }
]
}

const faqData = [
  [
    {
      question: "Do you provide service across all areas of Nanded MIDC?",
      answer: "Yes, our cab services cover all sectors of Nanded MIDC and nearby industrial zones, ensuring full-area coverage for employee and executive travel."
    },
    {
      question: "Can we set up shift-based recurring rides for staff?",
      answer: "Absolutely. We offer recurring ride scheduling for fixed and rotating shifts, helping businesses maintain punctual operations."
    },
    {
      question: "Is monthly billing with ride summaries available?",
      answer: "Yes, we offer monthly invoicing with GST-compliant summaries that include detailed trip logs and fare breakdowns."
    },
    {
      question: "Are your drivers trained in corporate conduct and safety?",
      answer: "Yes, our drivers receive training in corporate etiquette, defensive driving, and safety protocols to provide a professional experience."
    },
    {
      question: "How do you ensure passenger safety during rides?",
      answer: "We use real-time GPS tracking, regular vehicle inspections, and enforce hygiene protocols to ensure the safety of all passengers."
    },
    {
      question: "Is there a dedicated contact for corporate support?",
      answer: "Yes, a dedicated account manager is assigned to every corporate client for direct assistance, customized planning, and fast resolution of issues."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Pravin Kale",
    designation: "Admin Manager, Sunrise Agro Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has transformed our employee transport operations in Nanded MIDC. Their service is reliable, well-coordinated, and hassle-free.”"
  },
  {
    name: "Ms. Swati Kulkarni",
    designation: "HR Executive, Nova Plastics",
    rating: [1, 1, 1, 1, 1],
    text: "“Excellent service quality and great driver behavior. Our team feels safe and well cared for with eTravo’s cab services in Nanded MIDC.”"
  }
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Nanded MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-nanded-midc.jpg",
  "description": "Reliable and affordable corporate cab service in Nanded MIDC for employee transport, business meetings, and industrial area commutes. Book AC corporate cabs with professional drivers at eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "7034"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-nanded-midc"
  }
};





    return (
        <div>

<Helmet>
  <title>Cab Service in Nanded MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Nanded MIDC for corporate staff transport, business meetings, and industrial commutes. Reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinnanded;